import {
  ApiTokenListResponse,
  AppointmentCustomerDTO,
  AppointmentDTO,
  AppointmentPurchaseSummaryDTO,
  AppointmentSummaryAsMemberPostDTO,
  InvoiceDTO,
  MemberAppointmentPostDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerAppointmentApiType = ReturnType<
  typeof customerAppointmentApi
>;

const customerAppointmentApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    id(appointmentId: number) {
      return axiosInstance.get<AppointmentDTO>(
        `${clubPrefix}customer/appointment/${appointmentId}`,
      );
    },
    create(params: MemberAppointmentPostDTO) {
      return axiosInstance.post<{
        appointment: AppointmentDTO;
        invoice: InvoiceDTO;
      }>(`${clubPrefix}customer/appointment`, params);
    },
    update({
      appointment,
      appointmentId,
    }: {
      appointment: Partial<MemberAppointmentPostDTO>;
      appointmentId: number;
    }) {
      return axiosInstance.patch(
        `${clubPrefix}customer/appointment/${appointmentId}`,
        appointment,
      );
    },
    lateCancel({
      paymentMethodId,
      appointmentId,
    }: {
      paymentMethodId?: string;
      appointmentId: number;
    }) {
      return axiosInstance.put(
        `${clubPrefix}customer/appointment/${appointmentId}/late-cancel`,
        { paymentMethodId },
      );
    },
    summary(params: AppointmentSummaryAsMemberPostDTO) {
      return axiosInstance.post<AppointmentPurchaseSummaryDTO>(
        `${clubPrefix}customer/appointment/summary`,
        params,
      );
    },
    appointmentUpcoming({
      filters,
    }: {
      filters: {
        limit?: number;
        nextPageToken?: string;
        appointableId?: number[];
        appointmentHostId?: string[];
        appointableCategoryId?: number[];
        appointmentFacilityId?: number[];
      };
    }) {
      return axiosInstance.get<ApiTokenListResponse<AppointmentCustomerDTO>>(
        `${clubPrefix}customer/appointment/upcoming`,
        { params: filters },
      );
    },
    appointmentPast({
      filters,
    }: {
      filters: {
        limit?: number;
        nextPageToken?: string;
        appointableId?: number[];
        appointmentHostId?: string[];
        appointableCategoryId?: number[];
        appointmentFacilityId?: number[];
      };
    }) {
      return axiosInstance.get<ApiTokenListResponse<AppointmentCustomerDTO>>(
        `${clubPrefix}customer/appointment/past`,
        { params: filters },
      );
    },
  };
};

export default customerAppointmentApi;
